import { PimoReactComponent } from "@pimo/pimo-app-builder";
import { PMPopUp } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";
import { ReactNode } from "react";
import ReactHtmlParser from "react-html-parser";

interface TrialExpiredModalProps {
  open: boolean;
  language?: string;
}

export const TrialExpiredModal: PimoReactComponent<TrialExpiredModalProps> = ({
  open,
  language = "en",
}) => {
  return (
    <PMPopUp
      open={open}
      showCloseButton={false}
      title={getLocalizedMessage(language, "dialog.title.trialExpired")}
      description={
        ReactHtmlParser(
          getLocalizedMessage(language, "dialog.message.trialExpired")
        ) as ReactNode
      }
      confirmationButtonColor="blue"
      confirmationButtonText={getLocalizedMessage(
        language,
        "dialog.button.contactPimoTeam"
      )}
      confirmationButtonFireEvent={() => {
        window.open("mailto:contact@pimoapp.com");
      }}
      fullWidth
      maxWidth="md"
    ></PMPopUp>
  );
};
